module.exports = __webpack_public_path__ + "assets/img/062fc28affa1165bd29d91f0928592f1.svg";